import React, {useState} from 'react';
import {Checkbox, FormGroup} from 'react-bootstrap';

const HideSetting = (
    {
        title,
        name,
        value = false,
        onUpdate
    }
) => {
    const [isSetted, setIsSetted] = useState(value || false);

    return (
        <FormGroup style={{display: 'flex', alignItems: 'center', columnGap: '20px'}}>
            <Checkbox
                checked={isSetted}
                value={isSetted}
                name={name}
                onChange={(e) => { setIsSetted(e.target.checked); onUpdate({[name]: e.target.checked})}}
            >
                {title}
            </Checkbox>
        </FormGroup>
    )
}

export default HideSetting;